import {
	useGet21ProgressQuery,
	useGet330DetailQuery,
	useGetMajorProgressQuery,
} from '@/api/user/userApiSlice';
import AppFieldView from '@/common/components/form-view/AppFieldView';
import { Box, Button, CardContent, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import dayjs from 'dayjs';
import { DISPLAY_DATETIME_12H_FORMAT } from '@/utils/dateHelper';
import EastIcon from '@mui/icons-material/East';

interface Props {}
export default function UserExerciseProgress(props: Props) {
	const { t } = useTranslation();
	const { id } = useParams();
	const navigate = useNavigate();

	const { data: user21Progress } = useGet21ProgressQuery(id || '', {
		refetchOnMountOrArgChange: true,
	});
	const { data: userMajorProgress } = useGetMajorProgressQuery(id || '', {
		refetchOnMountOrArgChange: true,
	});

	return (
		<>
			<CardContent sx={{ padding: '24px' }}>
				<Box display='flex' justifyContent='space-between'>
					<Typography variant='h6'>{t('user.series21')}</Typography>
					<Button
						endIcon={<EastIcon />}
						color='secondary'
						onClick={() =>
							navigate(`/user-manage/user-list/info/${id}/series-21`)
						}
					>
						{t('user.viewAll')}
					</Button>
				</Box>
				<Grid container spacing={3} marginTop={0} marginBottom={3}>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.finishSeries21')}
							value={`${user21Progress?.data?.finishedCount || 0}/${
								user21Progress?.data?.seriesCount || 0
							}`}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.progressUpdateTime')}
							value={
								user21Progress?.data.updatedAt
									? dayjs(user21Progress?.data.updatedAt)
											.locale('en')
											.format(DISPLAY_DATETIME_12H_FORMAT)
									: '-'
							}
						/>
					</Grid>
				</Grid>
				<Divider />

				<Box
					display='flex'
					justifyContent='space-between'
					sx={{ paddingTop: '24px' }}
				>
					<Typography variant='h6'>{t('user.majorSeries')}</Typography>
					<Button
						endIcon={<EastIcon />}
						color='secondary'
						onClick={() => navigate(`/user-manage/user-list/info/${id}/major`)}
					>
						{t('user.viewAll')}
					</Button>
				</Box>
				<Grid container spacing={3} marginTop={0} marginBottom={3}>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.finishSeries')}
							value={`${userMajorProgress?.data?.finishedCount || 0}/${
								userMajorProgress?.data?.seriesCount || 0
							}`}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.progressUpdateTime')}
							value={
								userMajorProgress?.data.updatedAt
									? dayjs(userMajorProgress?.data.updatedAt)
											.locale('en')
											.format(DISPLAY_DATETIME_12H_FORMAT)
									: '-'
							}
						/>
					</Grid>
				</Grid>
				<Divider />
			</CardContent>
		</>
	);
}
